module.exports = __webpack_public_path__ + "img/textSelectionExample.27ede67d.png";